/** @format */

import React, { createRef, useState } from 'react';
import { FilterPod, TableComponents } from 'components';
import { toFilterVOS } from 'components/FilterPod';
import { enifyDateTime } from 'utility';
import { Box, Grid } from '@mui/material';
import AssignedDelegationServices from '../../services/ReceivedDelegationServices';
import { columns, generateData } from './Columns';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

const AssignedDelegation = ({ delegationId }) => {
  // -- STATES --//
  const {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    page,
    setPage,
  } = useCustomHook();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const currencyText = useCurrencyUnit();

  // --HOOKS--//
  const tableRef = createRef();

  const getDelegations = async (query) => {
    try {
      setLoading(true);

      let orderBy = [];
      let orderByName = null;

      switch (query?.orderBy?.title) {
        case 'شماره':
          orderByName = 'شناسه اعتبار';
          break;
        case 'شماره فاکتور':
          orderByName = 'شناسه فاکتور';
          break;
        case `به میزان - ${currencyText}`:
          orderByName = 'میزان';
          break;
        case 'کسب‌وکار':
          orderByName = 'نام کسب‌وکار';
          break;
        case 'توضیحات':
          orderByName = 'توضیحات فاکتور';
          break;
        case 'وضعیت':
          orderByName = 'وضعیت فاکتور';
          break;
        case `میزان مصرف -${currencyText}`:
          orderByName = 'میزان مصرف';
          break;
        case 'زمان مصرف':
          orderByName = query?.orderBy?.title;
          break;

        default:
          break;
      }
      if (orderByName) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }

      const filter = toFilterVOS([...filters]);

      const params = {
        delegationId,
        page: query ? query?.pageNumber : page,
        size: query?.pageSize || size,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await AssignedDelegationServices.getDelegationConsumption(data, params);

      let list = [];
      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      const newData = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };

      setLoading(false);

      return newData;
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="end" alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      {currencyText && (
        <TableComponents
          data={getDelegations}
          columns={columns(currencyText)}
          ref={tableRef}
          isLoading={loading}
          onChange={(ps) => {
            setPage(ps?.pageNumber);
            setSize(ps?.pageSize);
            return getDelegations(ps);
          }}
        />
      )}
    </>
  );
};

export default AssignedDelegation;
